import React, { useRef, useState } from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import HoverEvent from 'components/HoverEvent/HoverEvent'
import { useIsomorphicLayoutEffect } from 'hooks'

import FeatureWithRating from '../KeyFeatures/components/FeatureWithRating'

import classes from './FeaturesBreakdownTooltip.module.scss'

const FeaturesBreakdownTooltip = ({ children, features = [] }) => {
  const [tooltipPos, setTooltipPos] = useState(0)
  const ref = useRef(null)

  useIsomorphicLayoutEffect(() => {
    setTooltipPos({ left: ref?.current?.offsetWidth / 2 - 326 / 2, top: ref?.current?.offsetHeight + 5 })
  }, [])

  return (
    <HoverEvent
      className={clsx('FeaturesBreakdownTooltip', classes.tooltip)}
      role="tooltip"
      event={{
        name: 'engagement_product_click',
        engagementDetails: 'text-link_see-list',
        engagementDestination: 'expand_key-features',
        engagementComponent: 'best-product_card-item',
      }}
    >
      <span ref={ref} className={classes.childContainer}>
        {children}
      </span>
      <div className={classes.tooltipContentWrapper} style={{ left: `${tooltipPos.left}px` }}>
        <div className={classes.arrow} />
        <div className={classes.tooltipContent}>
          <Container>
            {features.map((feature, index) => (
              <FeatureWithRating key={index} feature={feature} />
            ))}
          </Container>
        </div>
      </div>
    </HoverEvent>
  )
}

export default FeaturesBreakdownTooltip
